import React, { Dispatch, useCallback, useEffect, useState } from 'react';
import classes from './configDialog.module.scss';
import { ReactComponent as Exit } from '../../assets/images/newClose.svg';
import Filter from '../ui/Filter';
import {
  useLimit,
  useMaxLimit,
  useReceived,
  useSent,
  useStaff,
  useThanks,
} from '../../hooks/entityHooks';
import { ThanksItemReceived } from '../ThanksItem/received';
import { ThanksItemSent } from '../ThanksItem/sent';
import { Thank } from '../../types/thank';
import { Staff } from '../../types/subdivision';
import { PreLoader } from '../PreLoader';

type Config = {
  state: boolean;
  type: number;
};
type props = {
  id?: number;
  setConfig: Dispatch<Config>;
  config: Config;
};

export const ThanksBlock = ({ id, setConfig, config }: props) => {
  const [stateFilter, setStateFilter] = useState<boolean>(true);
  const [idFilter, setIdFilter] = useState<number>();
  const { getEntity: getStaff, entity: info } = useStaff();
  const { getEntity: getLimit, entity: limit } = useLimit();
  const { getEntityList: getMaxLimit, entityList: maxLimit } = useMaxLimit();
  const {
    getEntity: getReceived,
    entity: receivedList,
    initLoading: initLoadingReceived,
  } = useReceived();
  const {
    getEntity: getSent,
    entity: sentList,
    initLoading: initLoadingSent,
  } = useSent();
  const { blockUser, updateEntity } = useThanks();

  const onChangeDelete = (id: number) => {
    return blockUser(id, 'Delete').then(() => {
      info && updateDependences(info);
    });
  };
  const onChangeUpdate = async (id: number, description: string) => {
    const data = {
      id,
      description,
    } as Thank;
    updateEntity(data).then((r) => {
      info && updateDependences(info);
      return r;
    });
  };
  const changeFilter = (id: number) => {
    const searchParams = new URLSearchParams();
    searchParams.append('valueID', id.toString());
    if (info && info.employeeGUID) {
      if (id !== Infinity) {
        stateFilter
          ? getReceived(info.employeeGUID, searchParams).then(() => {
              setIdFilter(id);
            })
          : getSent(info.employeeGUID, searchParams).then(() => {
              setIdFilter(id);
            });
      } else {
        updateDependences(info, id);
      }
    }
  };

  const resetInput = () => {
    changeFilter(Infinity);
  };

  useEffect(() => {
    if (id) {
      getStaff(id);
      getMaxLimit();
    }
  }, []);

  const updateDependences = useCallback(
    (info: Staff, id?: number) => {
      const limit = getLimit(info.employeeGUID);
      const received = getReceived(info.employeeGUID);
      const sent = getSent(info.employeeGUID);
      id &&
        Promise.all([limit, received, sent]).then(() => {
          setIdFilter(id);
        });
    },
    [info],
  );

  useEffect(() => {
    info && updateDependences(info);
  }, [info]);
  // @ts-ignore
  const maxLimitValue = maxLimit && maxLimit.limit;
  const limitValue = limit && maxLimitValue && maxLimitValue - limit.limit;
  return (
    <>
      <div className={classes.container}>
        <div className={classes.container__title}>
          <p>Спасибо</p>
          <Exit onClick={() => setConfig({ type: 1, state: false })} />
        </div>
        <div className={classes.container__filterWrapper}>
          <Filter type="Window" id={idFilter} onChange={changeFilter} />
          <div className={classes.container__filterTwo}>
            <p
              onClick={() => {
                setStateFilter(true);
                if (idFilter !== Infinity) {
                  resetInput();
                }
              }}
              className={stateFilter ? classes.orange : ''}
            >
              Сотруднику ({receivedList?.length})
            </p>
            <p
              onClick={() => {
                setStateFilter(false);
                if (idFilter !== Infinity) {
                  resetInput();
                }
              }}
              className={!stateFilter ? classes.orange : ''}
            >
              От сотрудника ({limitValue && limitValue}/
              {maxLimitValue && maxLimitValue})
            </p>
          </div>
        </div>
        <div className={classes.container__wrapperThanksBlock}>
          {stateFilter ? (
            initLoadingReceived ? (
              <PreLoader />
            ) : (
              receivedList &&
              receivedList.map((item) => (
                <ThanksItemReceived
                  onChangeDelete={onChangeDelete}
                  onChangeUpdate={onChangeUpdate}
                  item={item}
                  key={item.id}
                />
              ))
            )
          ) : initLoadingSent ? (
            <PreLoader />
          ) : (
            sentList &&
            sentList.map((item) => (
              <ThanksItemSent
                onChangeDelete={onChangeDelete}
                onChangeUpdate={onChangeUpdate}
                item={item}
                key={item.id}
              />
            ))
          )}
        </div>
      </div>
    </>
  );
};
